import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ThirdPartsAuthenticationList } from '~modules/thirdparts/common/entities/third-parts-authentication-list.entity';
import { ThirdPartsCashAndRepairAuthenticationManualCreateUpdateRequest } from '~modules/thirdparts/cash-and-repair/entities/third-parts-cash-and-repair-authentication-manual-create-update-request';
import { environment } from 'src/environments/environment';



@Injectable()
export class ThirdPartsCashAndRepairAuthenticationService {

  constructor(private readonly http: HttpClient) { }

  public list$(): Observable<ThirdPartsAuthenticationList[]> {
    const path = `${environment.apiURL}/third-parts/cash-and-repair/authentication/list`;
    return this.http.get<ThirdPartsAuthenticationList[]>(path);
  }

  public createOrUpdate$(request: ThirdPartsCashAndRepairAuthenticationManualCreateUpdateRequest) {
    const url = `${environment.apiURL}/third-parts/cash-and-repair/authentication`;

    return this.http.post<void>(url, request);
  }
}
